import { IViewSettings } from "./ViewSettings"

export const SHOW_NOT_RELEVANT_INVOICES = false

export interface IViewSettingsIncomingInvoices {
    showNotRelevantInvoices?: boolean
}

export default class ViewSettingsIncomingInvoices implements IViewSettings {
    showNotRelevantInvoices: boolean = SHOW_NOT_RELEVANT_INVOICES

    constructor(data: IViewSettingsIncomingInvoices) {
        if (typeof data.showNotRelevantInvoices !== "undefined") {
            this.showNotRelevantInvoices = data.showNotRelevantInvoices
        }
    }

    get isDefault() {
        return this.showNotRelevantInvoices === SHOW_NOT_RELEVANT_INVOICES
    }
}
